import { ref, onMounted, onUnmounted } from "vue";
import { LARGE_SCREEN_SIZE } from "@/utils/const";

/**
 * Composable for managing screen size and responsive behavior
 */
export function useScreenSize() {
  const windowWidth = ref(0);

  const getScreenSize = () => {
    windowWidth.value = window.innerWidth;
  };

  const isLargeScreen = () => {
    return windowWidth.value >= LARGE_SCREEN_SIZE;
  };

  onMounted(() => {
    window.addEventListener("resize", getScreenSize);
    getScreenSize();
  });

  onUnmounted(() => {
    window.removeEventListener("resize", getScreenSize);
  });

  return {
    windowWidth,
    isLargeScreen,
    LARGE_SCREEN_SIZE,
  };
}
